import * as types from "../../constants/actionTypes";
import initialState from "./initialState";

export function topologies(state = initialState.topologies, action) {
  switch (action.type) {
    case types.FETCH_MYTOPOS_SUCCESS:
      return [...state, action.returnTopos];

    default:
      return state;
  }
}

export function machineTasks(state = initialState.machineTasks, action) {
  switch (action.type) {
    case types.FETCH_TASKS_SUCCESS:
      return action.returnValue;
    case types.FETCH_TASKS_ERROR:
    case types.CLOSE_TASKS:
      return initialState.machineTasks;

    default:
      return state;
  }
}

export function vsRemoteDebuggerPort(state = initialState.vsRemoteDebuggerPort, action) {
  switch (action.type) {
    case types.FETCH_DEBUGGER_PORT_SUCCESS:
      return action.port;

    default:
      return state;
  }
}
